import { API_ROUTE_TRADE_IN_CUSTOMER_AGREEMENTS } from '@/resources/api-routes'
import { get } from '@/util/auth'

type AgreementOriginal = {
  id: string
  modifiedOn: string
  modifiedBy: string
  createdOn: string
  createdBy: string
  agreementText: string
  acceptedOn: string
  acceptedBy: string
  commission: number
  expirationDate: string
  activeFrom: string
}

const IS_NEW_BACKEND_API = true

export const getCustomerTradeInAgreements = async (customerId: number) =>
  await get<AgreementOriginal[]>(
    API_ROUTE_TRADE_IN_CUSTOMER_AGREEMENTS.replace(':customerId', String(customerId)),
    IS_NEW_BACKEND_API
  )
